var map = {
	"./add.svg": "9f25",
	"./again.svg": "ac3f",
	"./grade.svg": "e9cc",
	"./green_add.svg": "0bb0",
	"./next.svg": "c986",
	"./order.svg": "2931",
	"./ordered.svg": "212f",
	"./original.svg": "0820",
	"./play.svg": "0cb5",
	"./playing1.svg": "db38",
	"./playing2.svg": "2be5",
	"./reduce.svg": "6ee5",
	"./refresh.svg": "0d46",
	"./search.svg": "d162",
	"./top.svg": "3953"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "e456";